import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptors } from "../../app/store/baseQueryWithReauth";
import { reducerPathEnums } from "../../shared/types/common-types";
import type { LessonType } from "../Lesson/types";

export type CourseType = {
	_id: string;
	name: string;
	description: string;
	language: string;
	category: string;
	goals: string[];
	lessons: LessonType[];
	image: string;
	public: boolean;
	createdAt: string;
	updatedAt: string;
};

export interface CourseState {
	courseId: string;
}

const initialState: CourseState = {
	courseId: "",
};

const courseSlice = createSlice({
	name: "course",
	initialState,
	reducers: {
		setCourseId: (state, action) => {
			state.courseId = action.payload;
		},
	},
});

export const courseApi = createApi({
	reducerPath: reducerPathEnums.Course,
	tagTypes: ["Course"],
	baseQuery: baseQueryWithInterceptors,
	endpoints: (builder) => ({
		getCourses: builder.query<CourseType[], void>({
			query: () => "courses",
		}),
		getCourseById: builder.query<
			{ course: CourseType; isEnrolled: boolean },
			string
		>({
			query: (id = "") => `courses/${id}`,
			providesTags: (result, error, courseId) => [
				{ type: "Course", id: courseId },
			],
		}),
	}),
});

export const { setCourseId } = courseSlice.actions;

export default courseSlice.reducer;

export const {
	useGetCoursesQuery,
	useGetCourseByIdQuery,
	useLazyGetCoursesQuery,
} = courseApi;
